__turbopack_context__.v({
  "brand": "ApiIntegrations-module__DHarfa__brand",
  "brandInvert": "ApiIntegrations-module__DHarfa__brandInvert",
  "brands": "ApiIntegrations-module__DHarfa__brands",
  "card": "ApiIntegrations-module__DHarfa__card",
  "cdesc": "ApiIntegrations-module__DHarfa__cdesc",
  "ctitle": "ApiIntegrations-module__DHarfa__ctitle",
  "dynamicIcon": "ApiIntegrations-module__DHarfa__dynamicIcon",
  "eyebrow": "ApiIntegrations-module__DHarfa__eyebrow",
  "grid": "ApiIntegrations-module__DHarfa__grid",
  "head": "ApiIntegrations-module__DHarfa__head",
  "section": "ApiIntegrations-module__DHarfa__section",
  "subtitle": "ApiIntegrations-module__DHarfa__subtitle",
  "title": "ApiIntegrations-module__DHarfa__title",
});
